import { Component, Prop, Vue} from "vue-property-decorator";
import { ToastOptions } from "@/models";

const dateToast = new ToastOptions('warning', 'Invalid Date Test', 'Date!', 'This is a Test Date Toast', '');
const countToast = new ToastOptions('warning', 'Invalid Count Test', 'Count!', 'This is a Test Count Toast', '');
const syncToast = new ToastOptions('success', 'Invalid Sync Test', 'Sync!', 'This is a Test Sync Toast', '');

export const data = {
    dateToast: dateToast,
    countToast: countToast,
    syncToast: syncToast
}
